module.exports = __webpack_public_path__ + "img/map-marked.45c01d66.svg";